import { extends as _extends } from '../../../../../../../_virtual/_rollupPluginBabelHelpers.js';

/**
 * Takes a list of class names and filters for truthy ones, joining them into a single class name for convenience.
 * eg.
 * ```js
 *  cx('red', isBig && 'big') // returns 'red big' if `isBig` is true, otherwise returns 'red'
 * ```
 * If arguments provided are objects, these objects are merged together, and the values are taken as class names:
 *
 * ```js
 *  cx({ color: 'class1', textDecoration: 'class2'}, { color: 'class3' }) // returns `class3 class2`
 * ```
 *
 * @returns the combined, space separated class names that can be applied directly to the class attribute
 */
var cx = function cx() {
  var presentClassNames = Array.prototype.slice.call(arguments).filter(Boolean); // In the basic case, `cx` is passed all strings, and we simply need to join them together with space separators

  var classNamesResult = presentClassNames.filter(function (arg) {
    return typeof arg !== 'object';
  }); // There might also be objects (eg. from the atomic API) such as cx('foo', {
  // key1: 'bar', key2: 'fizz'}, { key1: 'buzz' }) the desired behavior is to
  // deduplicate the values based on their properties. The object's values are
  // the class names

  var styleCollectionResult = Object.values(_extends.apply(void 0, [{}].concat(presentClassNames.filter(function (arg) {
    return typeof arg === 'object';
  }))));
  return [].concat(styleCollectionResult, classNamesResult).join(' ');
};

export { cx as default };
